import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';
import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * GpBoldProductOptions Atom Module
 */
export class GpBoldProductOptions extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Bold Product Options';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'bold-product-options';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
